export const UPDATE_JOURNEY_STATE = "UPDATE_JOURNEY_STATE"
export const UPDATE_JOURNEY_LIST = "UPDATE_JOURNEY_LIST"